export function BackgroundGradient() {
    return (
        <div className="fixed inset-0">
            <div className="absolute inset-0 bg-gradient-to-br from-slate-100 to-white" />
            <div className="absolute inset-0" style={{
                background: `linear-gradient(105deg, 
         transparent 35%, 
         rgba(203, 213, 225, 0.1) 35.1%, 
         rgba(203, 213, 225, 0.1) 36%, 
         transparent 36.1%,
         transparent 38%,
         rgba(203, 213, 225, 0.1) 38.1%,
         rgba(203, 213, 225, 0.1) 39%,
         transparent 39.1%,
         transparent 65%,
         rgba(203, 213, 225, 0.1) 65.1%,
         rgba(203, 213, 225, 0.1) 66%,
         transparent 66.1%,
         transparent 68%,
         rgba(203, 213, 225, 0.1) 68.1%,
         rgba(203, 213, 225, 0.1) 69%,
         transparent 69.1%)`
            }} />
        </div>
    );
}
